import { Flex, Text, Title } from '@collable/ui'

const LoginHeader = () => {
  return (
    <Flex direction="column" alignItems="center" gap={20} as="header">
      <Title size="title1" fontWeight="bold" as="h1" color="labelNormal">
        콜라블(크리에이터) 시작하기
      </Title>
      <Text size="body2" fontWeight="regular" color="labelAlternative">
        지금 로그인하고 유튜브 콘텐츠를 손쉽게 관리하세요. <br />
        콜라블을 통해 대행사들에게 채널을 홍보할 수 있어요!
      </Text>
    </Flex>
  )
}

export default LoginHeader
